<ids-modal [(open)]="openModal" width="600px" (openChange)="isOpenChange($event)">
  <div class="ids-p-6">
    <h2 class="ids-mb-1 ids-insight -bold" idsModalTitle>
      Você tem certeza que deseja sair?
    </h2>
    <p>
      Todas as informações que foram preenchidas serão perdidas.
    </p>
  </div>
  <ids-modal-footer>
    <button idsMainButton variant="secondary" (click)="isOpenChange(false)">Cancelar</button>
    <button idsMainButton (click)="clickBackForm()">Sair sem salvar</button>
  </ids-modal-footer>
</ids-modal>
